<template lang="html">
  <div class="alert"
       :class="percentageValue >= 90 ? 'alert-danger' : 'alert-warning'"
       v-if="shouldShowAlert">
    <IconAlertWarning/>

    <div class="">
      <b>{{ $t('dashboard.usageFullMessage', {usagePercentage: percentageValue}) }}</b>
      <b>{{ `${percentageValue}%` }}</b>
      <p>{{ percentageValue >= 90 ? $t('dashboard.usageFullDangerMessage') : $t('dashboard.usageFullWarningMessage') }}</p>
    </div>

    <div class="">
      <a class="btn"
         :class="percentageValue >= 90 ? 'btn-danger' : 'btn-warning'"
         target="_blank" @click="toPlans">
         <span>{{ $t('dashboard.signUpNewPlan') }}</span>
         <span>{{ $t('plans.plans') }}</span>
      </a>
      <button class="btn"
              :class="percentageValue >= 90 ? 'btn-outline-danger' : 'btn-outline-warning'"
              type="button"
              name="button"
              data-test="btnClosePercentageAlert"
              aria-label="Close"
              v-show="percentageValue < 100"
              @click="handleDismiss">
        {{ $t('dashboard.seeLater') }}
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.alert {
  @include                              border_radius(0);
  padding:                              12px;
  display:                              flex;
  justify-content:                      space-between;
  gap:                                  10px;
  align-items:                          center;
  height:                               55px;
  margin:                               0;

  > div {
    a span,
    b {
      &:nth-child(2):not(:first-child) {
        display:                        none;
      }
    }

    &:not(:last-child) {
      flex:                             1;
    }

    &:last-child {
      display:                          flex;
      flex-direction:                   row;
      gap:                              20px;
    }
  }

  b {
    font-size:                          var(--font-size-14);
    white-space:                        nowrap;
  }

  p {
    font-size:                          var(--font-size-12);
    font-weight:                        400;
    margin:                             0;
  }

  .btn {
    font-weight:                        500;
    text-transform:                     uppercase;
    white-space:                        nowrap;
    padding:                            8px 20px;
  }

  .btn-warning,
  .btn-danger {
    color:                              white;
    font-size:                          12px;
    letter-spacing:                     2.64px;
  }

  .btn-outline-warning,
  .btn-outline-danger {
    font-size:                          11px;
    letter-spacing:                     2.42px;
    background:                         transparent;
  }

  .btn-outline-warning {
    color:                              #D8811B;
    border:                             1px solid #D8811B;
  }

  .btn-outline-danger {
    color:                              var(--Support-Error);
    border:                             1px solid var(--Support-Error);
  }

  .btn-warning {
    background:                         #D8811B;
    border:                             1px solid #D8811B;
  }

  .btn-danger {
    background:                         var(--Support-Error);
    border:                             1px solid var(--Support-Error);
  }

  &.alert-warning {
    color:                              #D8811B;
    background:                         #FFF8ED;
    border-top:                         1px solid #D8811B;
    border-bottom:                      1px solid #D8811B;
  }

  &.alert-danger {
    color:                              var(--Support-Error);
    background:                         #FFF1F1;
    border-top:                         1px solid var(--Support-Error);
    border-bottom:                      1px solid var(--Support-Error);
  }
}

@media (max-width: 991px) {
  .alert {
    margin:                             0;

    > div {
      a span,
      b,
      p {
        display:                        none;
      }

      a span,
      b {
        &:nth-child(2):not(:first-child) {
          display:                      block;
        }
      }
    }

    &.alert-warning,
    &.alert-danger {
      border-top-width:                 1px;
    }
  }
}
</style>

<script>
import { useUserStore } from '@/store/user'
import { useSubscriptionStore } from '@/store/subscription'

export default {
  name: 'MenuUsageAlert',
  data: () => ({
    loading: false,
    dismissedInSession: false,
  }),
  watch: {
    '$route.path'() {
      this.dismissedInSession = false;
    }
  },
  computed: {
    userStore() {
      return useUserStore();
    },
    subscriptionStore() {
      return useSubscriptionStore();
    },
    session() {
      return this.userStore.sessionInfo;
    },
    percentageValue() {
      return this.subscriptionStore.clinicUsage?.percentage || 0;
    },
    currentRoutePath() {
      return this.$route.path;
    },
    shouldShowAlert() {
      const percentageValue = this.percentageValue;
      const path = this.$route.path;

      if (path === '/dashboard' || percentageValue < 70) return false;

      if (this.dismissedInSession) return false;

      if (percentageValue >= 100) return true;

      if (percentageValue >= 70 && percentageValue < 90)
        return !localStorage.getItem('hideUsageAlert_70');

      if (percentageValue >= 90 && percentageValue < 100)
        return true;

      return false;
    }
  },
  mounted() {
    this.subscriptionStore.updateUsage(this.session.currentClinic.country)
  },
  methods: {
    toPlans() {
      this.$router.push('/plans/')
    },
    handleDismiss() {
      if (this.percentageValue >= 70 && this.percentageValue < 90)
        localStorage.setItem('hideUsageAlert_70', 'true');

      this.dismissedInSession = true;
      this.$emit('dismiss');
    }
  },
}
</script>
